import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=ced23842&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/3aece8dd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ced23842', component.options)
    } else {
      api.reload('ced23842', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=ced23842&", function () {
      api.rerender('ced23842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Profile.vue"
export default component.exports